import { scaleBand, ScaleBand } from "d3-scale";
import { ChartData } from "../interfaces/chart-data";
import { LineChartScaleSpecifics } from "./line-chart-scale-specifics";

export class LineChartBandScaleSpecifics
    implements LineChartScaleSpecifics<ScaleBand<string>> {
    public xScale(data: ChartData, width: number): ScaleBand<string> {
        return scaleBand()
            .domain(this.xAxisEntries(data))
            .range([0, width])
            .padding(0.2);
    }

    xAxisEntries(data: ChartData): string[] {
        return Object.keys(data);
    }

    mapValues(
        groupName: string,
        data: ChartData
    ): (k: string) => { key: string; value: number } {
        return (key) => ({ key: key, value: +data[key][groupName] });
    }

    /** Check if the max label width is too wide.
     * For band scales we can simply make use of bandwidth()
     */
    isXLabelTooWide(xScale: ScaleBand<string>, maxXTickLabelWidth: number) {
        {
            const bandScale = xScale as ScaleBand<string>;
            return maxXTickLabelWidth > bandScale.bandwidth() * 1.1;
        }
    }

    closestDataPointFnWith(data, xScale, offsetX, selectedGroup) {
        return (mx) => {
            const key = LineChartBandScaleSpecifics.scaleBandInvert(
                xScale,
                offsetX
            )(mx);
            const values =
                selectedGroup && selectedGroup in data[key]
                    ? { [selectedGroup]: data[key][selectedGroup] }
                    : data[key];
            return {
                key,
                values,
            };
        };
    }

    xOffset(xScale): number {
        return xScale.bandwidth() / 2;
    }

    xPositionForKey(xScale: ScaleBand<string>) {
        return (key: string) => xScale(key) + this.xOffset(xScale);
    }

    private static scaleBandInvert(scale, xOffset) {
        const domain = scale.domain();
        const paddingOuter = scale(domain[0]);
        const eachBand = scale.step();
        return function (value) {
            const index = Math.floor(
                (value - paddingOuter - xOffset) / eachBand
            );
            return domain[Math.max(0, Math.min(index, domain.length - 1))];
        };
    }
}
